export const headers = [
  { name: 'Nome Fantasia', field: 'company_social_name', sortable: true },
  { name: 'CNPJ', field: 'cnpj', sortable: true },
  { name: 'Telefone', field: 'phone', sortable: true },
  {
    name: 'Ativo',
    field: 'active',
    sortable: false,
    hasTypes: {
      types: {
        S: 'Sim',
        N: 'Não'
      }
    }
  },
  { name: 'Ações', field: 'actions', sortable: false }
]
